import React from 'react';
import moment from 'moment';
import { Button, Timeline, Input, Drawer, Form } from 'antd';
import { createRemark, getRemarks } from '../../service/report';
import { boundActions } from '../../store';
import './style.scss';

const { TextArea } = Input;

// 备注抽屉组件
export default function WithRemark(OriginalComponent) {
    return class Remark extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                remarkList: [],
                remarkLoading: false,
                flowId: ''
            };
        }
        remarkForm = React.createRef();
        static getDerivedStateFromProps(props, state) {
            if (props.match.params.flowId !== state.flowId) {
                return {
                    flowId: props.match.params.flowId
                };
            }
            return null;
        }
        componentDidMount() {
            this.getRemarkList();
        }
        componentDidUpdate(prevProps, prevState) {
            if (prevState.flowId !== this.state.flowId) {
                this.getRemarkList();
                // 重置redux中的remark和form的remark
                this.initRemark();
                this.remarkForm.current && this.remarkForm.current.setFieldsValue({ remark: '' });
            }
        }
        componentWillUnmount() {
            boundActions.getChangeRemarkAction({
                flowId: '',
                status: ''
            });
        }
        initRemark = () => {
            boundActions.getInitRemarkAction({
                flowId: this.state.flowId,
                content: ''
            });
        };
        getRemarkList = () => {
            getRemarks(this.state.flowId).then(({ result = [] }) => {
                this.setState({
                    remarkList: result
                });
            });
        };
        onFoldRemark = () => {
            boundActions.getChangeRemarkAction({
                status: 'fold'
            });
        };

        onCreateRemark = async (values) => {
            const { currentAgent } = this.props;
            const { flowId } = this.state;
            this.setState({
                remarkLoading: true
            });
            try {
                await createRemark(flowId, {
                    flowId,
                    agentId: currentAgent?._id || '',
                    content: values.remark
                });
                this.getRemarkList();
                // 提交备注后，清空redux中的备注内容，重置表单
                this.remarkForm.current.setFieldsValue({ remark: '' });
            } catch {}
            this.setState({
                remarkLoading: false
            });
        };
        render() {
            const { remark } = this.props;
            const { remarkList, remarkLoading } = this.state;
            return (
                <React.Fragment>
                    <OriginalComponent {...this.props} />
                    <Drawer
                        width="300"
                        placement="right"
                        visible={remark.status === 'unfold'}
                        title="备注"
                        onClose={this.onFoldRemark}
                        bodyStyle={{ padding: 10 }}
                        mask={false}
                    >
                        <div className="report-detail-remark">
                            <div className="report-detail-remark-list">
                                {remarkList.length ? (
                                    <Timeline>
                                        {remarkList.map((item) => {
                                            return (
                                                <Timeline.Item key={item._id} color="green">
                                                    <p>{moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}</p>
                                                    <p style={{ wordBreak: 'break-all' }}>{item.content}</p>
                                                </Timeline.Item>
                                            );
                                        })}
                                    </Timeline>
                                ) : (
                                    <p style={{ textAlign: 'center' }}>暂无备注内容</p>
                                )}
                            </div>
                            <div className="report-detail-remark-form">
                                <Form onFinish={this.onCreateRemark} ref={this.remarkForm}>
                                    <Form.Item
                                        name="remark"
                                        rules={[{ required: true, message: '请输入备注' }]}
                                    >
                                        <TextArea
                                            placeholder="请输入备注内容"
                                            style={{ height: 180 }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        shouldUpdate={(prevValues, curValues) =>
                                            prevValues.remark !== curValues.remark
                                        }
                                        noStyle
                                    >
                                        {({ getFieldValue }) => {
                                            const remark = getFieldValue('remark');
                                            return (
                                                <Form.Item>
                                                    <Button
                                                        loading={remarkLoading}
                                                        type="primary"
                                                        htmlType="submit"
                                                        disabled={!remark}
                                                        style={{ width: '100%' }}
                                                    >
                                                        确定
                                                    </Button>
                                                </Form.Item>
                                            );
                                        }}
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                    </Drawer>
                </React.Fragment>
            );
        }
    };
}
